export enum GiftOrderStatus {
  NoAddress = 'no_address',
  WaitShipped = 'wait_shipped',
  HasShipped = 'has_shipped',
  IsShipping = 'is_shipping',
  CancelShipment = 'cancel_shipment',
  CancelOrder = 'cancel_order',
}

export interface IGiftOrderInfo {
  gift_order_id: string
  name: string
  get_gift_time: string
  img_url: string
  status: GiftOrderStatus
}

export interface IGiftOrderDetail {
  gift_order_id: string
  name: string
  get_gift_time: string
  img_url: string
  status: string
  activity: string
  receiver: string
  phone: string
  province: string
  city: string
  district: string
  address: string
  tracking_company_name: string
  tracking_no: string
}

export interface ITeacherAddressInfoForm {
  province: string
  city: string
  district: string
  address: string
  phone: string
  name: string
  default: boolean
}

export interface ITeacherAddressInfo extends ITeacherAddressInfoForm {
  address_id: string
}
